import React from 'react';
import ChartIcon from '../../../../assets/Chart.png'
import PlaceIcon from '../../../../assets/place.png'
import StatsCard from '../../../../components/statsCard';
import { useGetTravellStateQuery } from '../../../../services/Api';
const StatsCards = () => {
    const { data, isLoading } = useGetTravellStateQuery()
    return (
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
            <StatsCard bg={`bgprimary`} title={`Total Traveller Profile`} value={data?.totalTravellers} icon={ChartIcon} />
            <StatsCard title={`Growth Rate`} value={data?.growthRate} icon={PlaceIcon} />
        </div>
    );
};

export default StatsCards;
